import { FormEvent, useEffect, useRef } from "react";
import cx from "classnames";
import "./FieldsetSelect.scss";

export interface SelectKeyValue {
  key: number;
  value: string;
}

interface FieldsetSelecttProps {
  dataTestId?: string;
  focus?: boolean;
  id: string;
  isDisabled?: boolean;
  items: SelectKeyValue[];
  label: string;
  name?: string;
  onBlur?: () => void;
  onChange: (event: FormEvent<HTMLSelectElement>) => void;
  placeholder?: string;
  validationMsg?: string;
  value?: string | number | readonly string[];
}
export const FieldsetSelect = (props: FieldsetSelecttProps) => {
  const { dataTestId, focus, id, isDisabled, items, label, name, onBlur, onChange, validationMsg, value } =
    props;

  const selectRef = useRef<HTMLSelectElement>(null);

  useEffect(() => {
    if (focus && selectRef.current) {
      selectRef.current.focus();
    }
  }, [focus]);

  return (
    <div className="fieldset-select-container">
      <fieldset
        className={cx("fieldset", {
          invalid: validationMsg,
          fieldsetWithLegend: label,
          disabled: isDisabled,
        })}
      >
        <legend>{label ? <label htmlFor={id}>{label}</label> : <></>}</legend>
        <select
          data-testid={dataTestId}
          id={id}
          disabled={isDisabled}
          name={name}
          onBlur={onBlur}
          onChange={onChange}
          // placeholder={placeholder}
          ref={selectRef}
          value={value}
        >
          {items.map((item) => {
            return (
              <option value={item.key} key={`${item.key}-${item.value}`}>
                {item.value}
              </option>
            );
          })}
        </select>
      </fieldset>
      {validationMsg ? <p className="validation-message">{validationMsg}</p> : <></>}
    </div>
  );
};
